import { render, staticRenderFns } from "./NotificationSendDetail.vue?vue&type=template&id=48f3874f&"
import script from "./NotificationSendDetail.vue?vue&type=script&lang=ts&"
export * from "./NotificationSendDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports